import styled, { keyframes } from 'styled-components';

import { URL_CITY } from 'apps/promo/constants/UrlConstants';
import promoColors from 'apps/promo/theme/promoColors';
import promoMedia from 'apps/promo/theme/promoMedia';
import zIndex from 'apps/promo/theme/zIndex';

const shouldForwardHeroProp = (prop) => !['countryToCode', 'secondRow'].includes(prop);

export const HeroContainer = styled.section.withConfig({ shouldForwardProp: shouldForwardHeroProp })`
    padding: 104px 0 32px;
    text-align: center;
    box-sizing: border-box;
    background:
        ${(props) => `url('${URL_CITY}/overlay-${props.countryToCode}-a.webp')`} center no-repeat,
        ${promoColors.oceanBlue01};
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 614px;
    position: relative;

    ${promoMedia.retina} {
        background:
            ${(props) => `url('${URL_CITY}/overlay-${props.countryToCode}-a@2x.webp')`} center no-repeat,
            ${promoColors.oceanBlue01};
        background-size: cover;
    }

    ${promoMedia.tablet744} {
        padding: 120px 0 48px;
        background:
            ${(props) => `url('${URL_CITY}/overlay-${props.countryToCode}-b.webp')`} center no-repeat,
            ${promoColors.oceanBlue01};
        background-size: cover;
    }

    ${promoMedia.retina744} {
        background:
            ${(props) => `url('${URL_CITY}/overlay-${props.countryToCode}-b@2x.webp')`} center no-repeat,
            ${promoColors.oceanBlue01};
        background-size: cover;
    }

    ${promoMedia.desktop1440} {
        text-align: left;
        padding: 152px 0 64px;
        background:
            ${(props) => `url('${URL_CITY}/overlay-${props.countryToCode}-c.webp')`} center no-repeat,
            ${promoColors.oceanBlue01};
        background-size: cover;
        min-height: 700px;
    }

    ${promoMedia.retina1440} {
        background:
            ${(props) => `url('${URL_CITY}/overlay-${props.countryToCode}-c@2x.webp')`} center no-repeat,
            ${promoColors.oceanBlue01};
        background-size: cover;
        min-height: 700px;
    }
`;

export const HeroContent = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: ${zIndex.landingHero};

    ${promoMedia.desktop1440} {
        flex-direction: row;
        min-height: 560px;
        align-items: center;
    }
`;

export const HeroTextBlock = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${promoMedia.desktop1440} {
        justify-content: flex-start;
    }

    ${promoMedia.retina1440} {
        justify-content: flex-start;
    }
`;

export const HeroTitle = styled.div`
    margin-bottom: 16px;
    word-break: break-word;

    ${promoMedia.tablet744} {
        margin-bottom: 24px;
    }

    ${promoMedia.desktop1440} {
        margin-bottom: 32px;
    }
`;

export const HeroSubtitle = styled.div.withConfig({ shouldForwardProp: shouldForwardHeroProp })`
    width: 100%;
    max-width: 335px;
    margin: 0 auto;
    margin-top: ${(props) => (props.secondRow ? '16px' : null)};

    ${promoMedia.tablet744} {
        max-width: 504px;
    }

    ${promoMedia.desktop1440} {
        max-width: 520px;
    }
`;

/* Banks section begin */
export const dotsSpinnerAnimation = keyframes`
    0% {
        background-color: ${promoColors.gray20};
        transform: scale(1.5);
    }
    50% {
        background-color: ${promoColors.gray5};
        transform: scale(1.25);
    }
    100% {
        background-color: ${promoColors.gray5};
    }
`;
export const DotsSpinner = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    span {
        background-color: ${promoColors.gray5};
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 8px;
        animation-name: ${dotsSpinnerAnimation};
        animation-duration: 1.2s;
        animation-iteration-count: infinite;
        animation-direction: alternate;

        &:nth-child(2) {
            animation-delay: 0.4s;
        }
        &:nth-child(3) {
            margin-right: 0;
            animation-delay: 0.8s;
        }
    }
`;
export const banksAnimation = keyframes`
    0% {
        opacity: 0;
    }
    7% {
        opacity: 0;
    }
    42% {
        opacity: 1;
    }
    50% {
        opacity: 1;
    }
    57% {
        opacity: 1;
    }
    85% {
        opacity: 0;
    }
    100% {
        opacity: 0;
    }
`;
export const AnimatedBank = styled.figure`
    animation: ${banksAnimation} 6s cubic-bezier(0.65, 0, 0.45, 1) infinite;
`;
export const BanksList = styled.ul`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    row-gap: 32px;
    margin-bottom: 32px;

    ${promoMedia.tablet744} {
        margin-bottom: 48px;
    }

    ${promoMedia.desktop1440} {
        margin-bottom: 64px;
    }
`;
export const BankItem = styled.li`
    width: 33.33%;
    text-align: center;

    ${promoMedia.desktop1440} {
        width: 16.66%;
    }

    img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-bottom: 16px;
    }
`;
/* Banks section end */
